import Basket from './basket';
import CreditCard from './creditCard';
import Currency from './currency';
import Customer from './customer';
import Passenger from './passenger';
import Payment from './payment';
import UserAgent from './userAgent';

export default class AddOrder {
  userAgent: UserAgent;
  basket: Basket;
  orderId: string;
  passengers: Passenger[];
  currency: Currency;
  isWeb: boolean;
  marker: string;
  customer: Customer;
  creditCard: CreditCard;
  payment: Payment;
  requestId: string;
  flightId:string;
  transferId:string;
  returnFlightId:string;
  hotelNote:string;
  flightNote:string;
}
